import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserFollowedDataSubjectValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'user-followed-data-subject-valid-form-data-schema',
);
addTranslations(translations);

export const UserFollowedDataSubjectValidFormDataSchema = z.object({
  dataSubjectId: z.number({
    errorMap: () => ({
      message: t('validation.dataSubjectId.required'),
    }),
  }),
  dataSubjectCode: z.string().optional(),
});
